
export class PerspectiveViewNotFoundError extends Error {}
